<script lang="ts">
  import { List } from 'flowbite-svelte'
  import { readerFontFamily } from '$lib/reader-fonts'
  import { readerOpts } from '$lib/store'
  import type { Snippet } from 'svelte'

  interface Props {
    ordered?: boolean
    start?: number
    children?: Snippet
  }

  const { ordered = false, start = 1, children }: Props = $props()
  const tag = $derived( ordered ? 'ol' : 'ul')
</script>

{#key $readerOpts}
  <List
    {tag}
    style="font-family: {readerFontFamily($readerOpts.bodyFont)};"
    class="space-y-1 text-gray-500 dark:text-gray-400 text-{$readerOpts.fontSize}"
  >
    {@render children?.()}
  </List>
{/key}

